"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genericTokens = void 0;
var _tokens = _interopRequireDefault(require("../../forecast-v2/shared/tokens/tokens"));
/**
 * Do not add any good old token you need in webfront here. We need to limit this to encourage re-use of DS tokens.
 *
 * For compnent specific tokens, where we do not want the component in the design system (like the calendar in timesheets)
 * we add a component specific token file in the component folder. see calendar.tokens.ts for an example.
 *
 * */

var genericTokens = exports.genericTokens = {
  color: {
    border: {
      focusring: _tokens.default.sky.sys.color.border.focusring
    }
  }
};